document.addEventListener("show.bs.tab", (e) => {
  const dom = document.activeElement;
  if (dom && dom.closest(".page-nav-close")) {
    e.preventDefault();

    const target = dom.closest(".page-nav");
    document.getElementById(`${target.attributes['data-bs-target'].nodeValue.substr(1)}`).remove()
    target.remove();
  }
});
